import { Box, Stack, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useSelector } from "react-redux";
import { toFirstOfMonth } from "../../deepViewDates";

const DateAffected = () => {
  const offsetMonth = useSelector(
    (state: any) =>
      state?.deepView?.deepViewData?.period?.fmt_offset_activity_month_year,
  );
  const offsetDate = toFirstOfMonth(offsetMonth);

  return (
    <Box
      sx={{
        border: "1px solid #E0E0E0",
        borderRadius: "8px",
        backgroundColor: "#FAFAFA",
        p: 1,
        mt: 1.5,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} mb={1}>
        <InfoOutlinedIcon
          sx={{
            color: "#00000099",
            fontSize: 18,
          }}
        />

        <Typography
          sx={{
            color: "#00000099",
            fontSize: "14px",
            fontWeight: 500,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          }}
        >
          Which date is affected?
        </Typography>
      </Stack>

      <Typography
        sx={{
          color: "#00000099",
          fontSize: "14px",
          lineHeight: "20px",
        }}
      >
        The offset is written to the <strong>{offsetDate ?? "-"}</strong> record
        only (first day of month). For all other dates in{" "}
        {offsetMonth ?? "this period"}, the offset is shown here for context —
        the individual date rows are not directly modified.
      </Typography>
    </Box>
  );
};

export default DateAffected;
